import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-show-message',
  templateUrl: './show-message.component.html',
  styleUrls: ['./show-message.component.scss'],
})
export class ShowMessageComponent implements OnInit, OnDestroy {
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
   // console.log('show-message');
  }

  close() {
    this.bsModalRef.hide();
    // this.modalService.onHide.unsubscribe();
  }
  ngOnDestroy() {
    // this.modalService.onHide.unsubscribe();
    this.modalService.onHide.unsubscribe();
  }
}
